var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device[data-v-570fb3f8]{border:1px solid transparent;cursor:pointer;display:inline-block;font-family:PxGroteskRegular;font-size:14.56px;text-align:center;transition:border .4s linear;vertical-align:top;width:33.3%}@media (min-width:768px){.device[data-v-570fb3f8]{width:25%}}@media (min-width:1920px){.device[data-v-570fb3f8]{width:20%}}.device.is-active[data-v-570fb3f8]{border:1px solid #fff;cursor:default;position:relative}.device.is-active[data-v-570fb3f8]:before{background:transparent url(" + escape(require("../../assets/checked.svg")) + ");content:\"\";height:7px;position:absolute;top:8px;right:9px;width:9px}.device__name[data-v-570fb3f8]{margin:0 auto;max-width:70%}.device img[data-v-570fb3f8]{height:auto;max-width:70%}.device__wrapper[data-v-570fb3f8]{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-570fb3f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/panels/Device.vue
// module id = 254
// module chunks = 0